var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 752"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630612",
    x: 3.5,
    y: 0.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630613",
    x: 0.5,
    y: 2.5,
    width: 3,
    height: 7,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630614",
    x: 14,
    y: 2,
    width: 2,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630615",
    x: 14,
    y: 9,
    width: 2,
    height: 1,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.ae00a5df4eabdd91c7ae0ce0842aa2c2.svg";
export { ForwardRef as ReactComponent };